import { PropsWithChildren } from 'react'

interface Props {
    isLoading: boolean
}
export default function Loader({
    isLoading,
    children,
}: PropsWithChildren<Props>) {
    if (isLoading) {
        return (
            <div className="flex justify-center my-4">
                <span className="loading loading-spinner loading-lg"></span>
            </div>
        )
    }

    return children
}
